import {User} from '@/types/user';
import {InitiatorClass} from '@/types/InitiatorClass';

export enum AppStateField {
  // Информация о пользователе
  USER = 'user',
  MESSAGE = 'message',
  INITIATOR = 'initiator'
}

export interface AppState {
  user?: User;
  initiator: InitiatorClass,
  message: {show: boolean, text: string, timeout: number}
}

export function getDefaultState(): AppState {
  return {
    user: undefined,
    initiator: {} as InitiatorClass,
    message: {
      show: false,
      text: '',
      timeout: 0
    }
  };
}
